import {
  breakpoints,
  Chip,
  DropdownMenu,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

import { Option } from '~/components/filter/Option';

export const StyledDropdownMenu = styled(DropdownMenu)`
  @media ${breakpoints.lsegMobile} {
    width: 240px;
    min-width: 240px;
  }
`;

export const PrefixText = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  ${typographyV2.bodySm};
`;

export const StyledChip = styled(Chip)`
  padding: 6px 8px;
  gap: 4px;

  ${Chip.Styled.LeftIcon},
  ${Chip.Styled.RightIcon} {
    margin-left: 8px;
  }
`;

export const StyledOptionWrapper = styled.div<{ $disabled: boolean }>`
  ${({ $disabled }) =>
    $disabled &&
    css`
      ${Option.Styled.ItemDescription} {
        color: var(--text-disabled);
      }
    `}
`;
